function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(-1095.406 -611.125)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(1095.406 611.125)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M1140.938,652.25h-44.062a1.469,1.469,0,0,1-1.469-1.468V618.469a1.469,1.469,0,0,1,1.469-1.469h9.373l2.532-5.064a1.47,1.47,0,0,1,1.314-.811h17.625a1.469,1.469,0,0,1,1.314.811l2.532,5.064h9.373a1.469,1.469,0,0,1,1.468,1.469v32.313A1.468,1.468,0,0,1,1140.938,652.25Zm-42.594-2.937h41.125V619.938h-8.812a1.47,1.47,0,0,1-1.314-.811l-2.532-5.064H1111l-2.532,5.064a1.469,1.469,0,0,1-1.314.811h-8.812Z",
  transform: "translate(-1095.406 -611.125)"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(1109.719 624.125)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M1116.406,640a9.188,9.188,0,1,1,9.188-9.187A9.2,9.2,0,0,1,1116.406,640Zm0-15.75a6.563,6.563,0,1,0,6.563,6.563A6.57,6.57,0,0,0,1116.406,624.25Z",
  transform: "translate(-1107.219 -621.625)"
})));

var SvgImageGallery = function SvgImageGallery(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 41.125,
    viewBox: "0 0 47 41.125",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgImageGallery, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/image_gallery.a2925e18.svg";
export { ForwardRef as ReactComponent };